// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"471":"859cfb56","671":"2215387d"}[chunkId] + ".chunk.js";
};